/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Luci_Shopping_Api_Models_ShippingAddress } from './Luci_Shopping_Api_Models_ShippingAddress';
export type Luci_Shopping_Api_Requests_CreatePayPalOrderRequest = {
  sessionId?: string;
  customerEmailAddress?: string;
  deliveryMethod?: Luci_Shopping_Api_Requests_CreatePayPalOrderRequest.deliveryMethod;
  shippingAddress?: Luci_Shopping_Api_Models_ShippingAddress;
};
export namespace Luci_Shopping_Api_Requests_CreatePayPalOrderRequest {
  export enum deliveryMethod {
    POINT_OF_SALE = 'PointOfSale',
    SHIPPING = 'Shipping',
    PICKUP = 'Pickup',
  }
}

